import formatObjectWithKeysAsArray from "lib/helpers/formatObjectWithKeysAsArray";
import regionSearch from "lib/helpers/regionSearch";
import apiData from "lib/stores/apiData";
import context from "lib/stores/context";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import DetailsPaneTable from "components/common/DetailsPane/DetailsPaneTable";
import DataPanelWrapper from "./DataPanelWrapper";
import SidebarSearch from "components/Sidebar/SidebarSearch";

const RegionsPanel = () => {
  const { regions, metadata } = useSnapshot(apiData, { sync: true });
  const [regionsArray, setRegionsArray] = useState([]);
  const [queryResults, setQueryResults] = useState([]);
  const { searchQuery, activeTabWorldwide } = useSnapshot(context, { sync: true });

  useEffect(() => {
    regionSearch.removeAll();
    const regionsArr = formatObjectWithKeysAsArray(regions);
    setRegionsArray(regionsArr);
    regionSearch.addAll(regionsArray);
  }, []);

  const isMounted = () => {
    if (activeTabWorldwide === 1) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!searchQuery) {
      setQueryResults([]);
    }
    const results = regionSearch.search(searchQuery, { prefix: true });
    setQueryResults([...results]);
  }, [searchQuery]);

  return (
    <DataPanelWrapper isMounted={() => activeTabWorldwide === 1}>
      <SidebarSearch />
      <DetailsPaneTable queryResults={queryResults} rows={regionsArray} />
    </DataPanelWrapper>
  );
};

export default RegionsPanel;
